import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = ['Llegás a clase sin saber exactamente qué ejercicios vas a dar hoy', 'Tus alumnos no progresan porque no hay un orden claro de contenidos semana a semana', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin dejar a nadie afuera', 'Cuando hay feriado o ausencia perdés la continuidad de la progresión y tenés que improvisar desde cero', 'No podés justificar un aumento de precio porque no tenés nada sistematizado que mostrar', 'Cada vez que entra un alumno con una hernia, una prótesis o una lesión sentís que no sabés qué hacer y eso te genera miedo', 'Pasás más tiempo planificando que disfrutando tu trabajo como instructor', 'Nadie valora tu trabajo porque no se ve reflejado en resultados concretos semana a semana'];
export function PainsSection() {
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-white" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-10 text-primary" data-id="element-165">
          Si sos instructor de stretching, esto te va a sonar conocido:
        </motion.h2>

        <div className="space-y-4 mb-12 bg-surface-light p-8 rounded-2xl" data-id="element-166">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex gap-4 items-start" data-id="element-167">
              <XIcon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-168" />
              <p className="text-gray-800 font-medium" data-id="element-169">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-170">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-171">
            "¿Cuántas clases más vas a improvisar?"
          </p>
          <button onClick={scrollToPricing} className="bg-accent text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-accent-dark transition-colors inline-flex items-center gap-2 shadow-lg" data-id="element-172">
            👉 BASTA DE IMPROVISAR — QUIERO MI STRETCHING 360
          </button>
        </motion.div>
      </div>
    </section>;
}